import { yupResolver } from '@hookform/resolvers/yup';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import React from 'react';
import { useForm } from 'react-hook-form';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ICardReplacementFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardOperations/CardReplacementFormMeta';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';

type Props = {
    meta: ICardReplacementFormMeta,
} & TFormUIProps;

const CardReplacementFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
        <>
            <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
              <CC.SimpleGrid columns={{base: 1, md: 2, lg: 3}} spacing={10} my={10}>
                  {displayCustomInputs<ICardReplacementFormMeta>(meta, register, errors, isLoading, [], ['replacementReason', 'replacementFee', 'replaceWithPINGeneration', 'replaceWithoutMaking'])}
              </CC.SimpleGrid>
              <CC.Box mt="2%" as="fieldset"
              p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'}>
                <CC.Heading px={2} as={"legend"} fontSize='md'>Carte à piste</CC.Heading>
                <CC.SimpleGrid columns={{base: 1, md: 2, lg: 3}} spacing={10} my={10}>
                  {displayCustomInputs<ICardReplacementFormMeta>(meta, register, errors, isLoading, ['replacementReason', 'replacementFee', 'replaceWithPINGeneration', 'replaceWithoutMaking'])}
                </CC.SimpleGrid>
              </CC.Box>
              <CC.HStack my={4} justifyContent={'flex-end'}>
                  <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
              </CC.HStack>
            </CC.Box>
        </>
  );
};

export default CardReplacementFormUI;
